import React from 'react';
const FieldItem = (props: {
  label: string;
  value: string | number | undefined;
  icon: string;
}) => {
  return (
    <div className="field-item">
      <span className="row-label">
        <i
          className="label-icon"
          style={{
            backgroundImage: `url(${props.icon})`,
          }}
        ></i>
        <i>{props.label || '—'}</i>
      </span>
      <span className="row-value">{props.value || '—'}</span>
    </div>
  );
};

export default FieldItem;
